import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { Potencia } from '../../common/types/Potencia'
import { useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemPotencia',
  props: {
	item: { type: Object as PropType<Potencia>, required: true },
},
  setup(__props) {

const props = __props;



const router = useRouter()

function onClickItemBusca() {
	router.push({
		name: 'detalhar-potencia',
		params: { id: props.item._id },
	})
}

return { __sfc: true,props, router, onClickItemBusca }
}

})